export * from './event-artist';
